export default "__VITE_ASSET__CqsYIMvK__"